<template>
  <CountrySelect v-model="country" :label="$tt('birth_country')" />
</template>

<script setup lang="ts">
import type { CountryIso } from '~/types';
const country = defineModel<CountryIso>({ required: true });
</script>